import { render, staticRenderFns } from "./EventsNavItems.vue?vue&type=template&id=34d3caaf&scoped=true&"
import script from "./EventsNavItems.vue?vue&type=script&lang=ts&"
export * from "./EventsNavItems.vue?vue&type=script&lang=ts&"
import style0 from "./EventsNavItems.vue?vue&type=style&index=0&id=34d3caaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d3caaf",
  null
  
)

export default component.exports